import { render } from "./BankIdFaker.vue?vue&type=template&id=c264beca"
import script from "./BankIdFaker.vue?vue&type=script&lang=js"
export * from "./BankIdFaker.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/System/Compenents/BankId/BankIdFaker.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c264beca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c264beca', __exports__)) {
    api.reload('c264beca', __exports__)
  }
  
  module.hot.accept("./BankIdFaker.vue?vue&type=template&id=c264beca", () => {
    api.rerender('c264beca', render)
  })

}


export default __exports__